import { render } from "./CorporateBranding.vue?vue&type=template&id=255b3832&scoped=true"
import script from "./CorporateBranding.vue?vue&type=script&lang=js"
export * from "./CorporateBranding.vue?vue&type=script&lang=js"

import "./corporate-branding.scss?vue&type=style&index=0&id=255b3832&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255b3832"]])

export default __exports__